// extracted by mini-css-extract-plugin
export var responsiveImageContainer = "ResponsiveImgixImage-module--responsive-image-container--06e85";